// extracted by mini-css-extract-plugin
export default {"wrapper":"GenerationLoading_wrapper__5domQ","color":"GenerationLoading_color__XfV7U","position":"GenerationLoading_position__+hOSa"};